var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpb-columns",style:(`--kpb-column-gap: ${_vm.gap}; --kpb-column-count: ${_vm.columns};`)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }